export const STORAGE_VERSION = 1;

const keyFor = (site) => `userFilterPresets:${site}`;

export const load = (site) => {
  try {
    const raw = localStorage.getItem(keyFor(site));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.v !== STORAGE_VERSION) {
      if (parsed && parsed.v !== STORAGE_VERSION) {
        // eslint-disable-next-line no-console
        console.warn(
          `[presetStorage] Ismeretlen verzió: ${parsed.v}, várt: ${STORAGE_VERSION}. Üres lista visszaadva.`
        );
      }
      return [];
    }
    return Array.isArray(parsed.presets) ? parsed.presets : [];
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[presetStorage] Sérült JSON, üres lista visszaadva:", err);
    return [];
  }
};

export const save = (site, presets) => {
  const payload = JSON.stringify({ v: STORAGE_VERSION, presets });
  localStorage.setItem(keyFor(site), payload);
};

export const addPreset = (site, preset) => {
  const presets = load(site);
  const existingIndex = presets.findIndex((p) => p.name === preset.name);
  let updated;
  if (existingIndex >= 0) {
    updated = [...presets];
    updated[existingIndex] = preset;
  } else {
    updated = [...presets, preset];
  }
  save(site, updated);
  return updated;
};

export const removePreset = (site, id) => {
  const presets = load(site);
  const updated = presets.filter((p) => p.id !== id);
  save(site, updated);
  return updated;
};
